import {createContext, useContext, type ReactNode} from 'react';
import type {useProductPage} from './use-product-page';

export type ProductPageState = ReturnType<typeof useProductPage>;

const ProductPageContext = createContext<ProductPageState | null>(null);

export function ProductPageProvider({value, children}: {value: ProductPageState; children: ReactNode}) {
	return <ProductPageContext.Provider value={value}>{children}</ProductPageContext.Provider>;
}

export function useProductPageContext(): ProductPageState {
	const value = useContext(ProductPageContext);
	if (!value) throw new Error('Раздел товара открыт вне страницы товара');
	return value;
}
